import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { OrganizationUserDetails } from '@/components/organizations/OrganizationUserDetails';
import { backendApiOrganizationsFindOneOrganizationUserOptions } from '@/modules/api/@tanstack/react-query.gen';
import { useMyOrganizationQuery } from '@/queries/useMyOrganizationQuery';

export const Route = createFileRoute('/_authenticated/_management/meine-organisation/benutzerinnen/$userId')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: UserDetailsRoute,
});

function UserDetailsRoute() {
  const { userId } = Route.useParams();
  const { data: organization } = useMyOrganizationQuery({
    adminLevels: true,
    users: true,
    stakeholders: true,
  });

  const { data: organizationUser } = useQuery({
    ...backendApiOrganizationsFindOneOrganizationUserOptions({ path: { organizationId: organization?.id!, userId } }),
    enabled: !!organization?.id,
  });

  return (
    organizationUser && (
      <OrganizationUserDetails organizationUser={organizationUser} parentRoute="/meine-organisation/benutzerinnen" />
    )
  );
}
